import { configureStore } from '@reduxjs/toolkit';
import { languageReducer } from '@digitaltattoo/redux-slices';
import authSlice from './slices/authSlice';
import preferencesSlice from './slices/preferencesSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    language: languageReducer,
    preferences: preferencesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;